import { z } from 'zod';
import { idValidator } from '@/schemas/common/validators';

// Request schema for bulk feature for partner
export const BulkFeatureForPartnerRequestSchema = z.object({
  listingIds: z.array(idValidator).min(1, 'At least one listing ID is required'),
  membershipType: idValidator,
});

export type BulkFeatureForPartnerRequest = z.infer<typeof BulkFeatureForPartnerRequestSchema>;

// Response schema for bulk feature for partner
export const BulkFeatureForPartnerResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    featured: z.literal(true),
    partner: z.string(),
    featuredCount: z.number(),
    alreadyFeaturedCount: z.number(),
    totalRequested: z.number(),
  }),
  z.object({
    success: z.literal(false),
    error: z.string(),
    found: z.number().optional(),
    requested: z.number().optional(),
    alreadyFeaturedCount: z.number().optional(),
    details: z.string().optional(),
  }),
]);

export type BulkFeatureForPartnerResponse = z.infer<typeof BulkFeatureForPartnerResponseSchema>;
